import { BoneTypeEnum, MechanicalAxisAP as MechanicalAxisAPBase, Save, StateTypes } from "@ortho-next/nextray-core";
import { Vector3 } from "three";
import { BindedModel } from "../../Models/BindedModel";
import { PrintStateTypes } from "../../States/State";

export class MechanicalAxisAP extends MechanicalAxisAPBase {
	@Save() public isValid!: boolean;

	constructor(isLeft: boolean, boneType: BoneTypeEnum, isContralateral: boolean, isEOC: boolean) {
		super(isLeft, boneType, isContralateral, isEOC);
		this.bindProperties(isContralateral, isEOC);
	}

	public override handleRegisteredPoints(points: Vector3[]): boolean {
		this.isValid = super.handleRegisteredPoints(points);
		return this.isValid;
	}

	private bindProperties(isContralateral: boolean, isEOC: boolean): void {
		if (!isEOC) {
			if (isContralateral) {

				this.bindProperty('visible', (m: BindedModel) => {
					return m.layer_contralateral_all && m.isControlateralMechanicalAxisValid && !m.insertingControlateralMechanicalAxis && ((!m.EOCCropVisible && m.printState === PrintStateTypes.none) || m.printState === PrintStateTypes.deformityAnalysis);
				}, ['layer_contralateral_all', 'isControlateralMechanicalAxisValid', 'insertingControlateralMechanicalAxis', 'EOCCropVisible', 'printState']);

			} else {

				this.bindProperty('visible', (m: BindedModel) => {
					return m.isMechanicalAxisAPValid && !m.insertingMechanicalAxisAP && ((!m.EOCCropVisible && m.printState === PrintStateTypes.none) || m.printState === PrintStateTypes.deformityAnalysis);
				}, ['isMechanicalAxisAPValid', 'insertingMechanicalAxisAP', 'EOCCropVisible', 'printState']);

			}

			this.bindProperty('isEnabled', (m: BindedModel) => {
				return !m.readonly && !m.isRegisteringClickAP && m.appState === StateTypes.deformityAnalysis;
			}, ['readonly', 'isRegisteringClickAP', 'appState']);

		}

		this.weightBearing?.bindProperty('visible', (m: BindedModel) => {
			return m.layer_mechAxis_weightBearing;
		}, ["layer_mechAxis_weightBearing"]);

		if (!isContralateral) {
			this.tibia?.bindProperty('visible', (m: BindedModel) => {
				return m.layer_mechAxis_mechanical;
			}, ['layer_mechAxis_mechanical']);

			this.femur?.mechanical?.bindProperty('visible', (m: BindedModel) => {
				return m.layer_mechAxis_mechanical;
			}, ['layer_mechAxis_mechanical']);

			this.femur?.anatomical?.bindProperty('visible', (m: BindedModel) => {
				return m.layer_mechAxis_anatomical;
			}, ['layer_mechAxis_anatomical']);
		}
	}
}  
